import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import SelectDropdown from '../../SelectDropdown/SelectDropdown';
import EditAccountPSPIndexModalItem from './EditAccountPSPIndexModalItem';
import {labels} from '../../../../util/utils';
import {pspIndexesConstants} from '../../../../util/uiconstants';

const EditAccountPSPIndexModal = (props) => {
	const availablePSPIndexes = useSelector((state) => state.pspIndexes);
	const [currentSelectedPSPIndex, setCurrentSelectedPSPIndex] = useState([]); // PSP indexes that the user has selected in this session.
	const [selectedPSPIndexes, setSelectedPSPIndexes] = useState(null); // PSP indexes that the user had previously selected for the account.
	const [pspIndexOptions, setPSPIndexOptions] = useState([]);
	const [isMaxPSPSelected, setIsMaxPSPSelected] = useState(false);

	useEffect(() => {
		if (
			availablePSPIndexes &&
			props.selectedPSPIndexes &&
			availablePSPIndexes.length > 0 &&
			props.selectedPSPIndexes.length > 0
		) {
			let options = [];
			options = availablePSPIndexes.filter((x) => {
				return !props.selectedPSPIndexes.find((y) => {
					return x.pspIndexId === y.cgpspIndexID;
				});
			});
			setPSPIndexOptions(options);
			let selectedPSPIndexInAccount = availablePSPIndexes.filter((x) => {
				let item = props.selectedPSPIndexes.find((y) => {
					return y.cgpspIndexID === x.pspIndexId || y.knowledgeContentID === x.knowledgeContentID;
				});
				if (item) {
					return {
						id: item.id,
						pspIndexId: item.cgpspIndexID,
						displayOrder: x.displayOrder,
						isEstimate: item.isEstimate,
						knowledgeContentId: item.knowledgeContentID,
						knowledgeModifyDate: item.knowledgeModifyDate,
						value: x.value,
						label: item.pspIndexTitle
					};
				}
				return;
			});
			setCurrentSelectedPSPIndex(selectedPSPIndexInAccount);
		} else {
			setPSPIndexOptions(availablePSPIndexes);
			setCurrentSelectedPSPIndex([]);
		}
	}, [availablePSPIndexes, props.selectedPSPIndexes]);

	useEffect(() => {
		if (currentSelectedPSPIndex) {
			setIsMaxPSPSelected(currentSelectedPSPIndex.length === pspIndexesConstants.MAX_PSP_INDEXES_SELECTED);
			setPSPIndexOptions((prevState) => {
				return removeSelectedOptionsFromAvailableOptions(prevState, currentSelectedPSPIndex);
			});
			props.onPSPIndexSelectionChange(currentSelectedPSPIndex);
		}
	}, [currentSelectedPSPIndex]);

	const optionSelectedHandler = (value) => {
		props.setChangesWithoutSave(true);
		let selectedOption = [];
		selectedOption.push(value);
		setCurrentSelectedPSPIndex((prevState) => {
			return [...prevState, ...selectedOption];
		});
		setSelectedPSPIndexes(null);
	};

	const removeSelectedOptionsFromAvailableOptions = (availableOptions, selectedOptions) => {
		let result = [];
		result = availableOptions.filter((x) => {
			return !selectedOptions.find((y) => {
				return x.pspIndexId === y.pspIndexId;
			});
		});
		return result;
	};

	const itemClickHandler = (item) => {
		props.setChangesWithoutSave(true);
		const deletedOption = currentSelectedPSPIndex.filter((x) => x.pspIndexId === item.id);
		setCurrentSelectedPSPIndex((prevState) => {
			const result = prevState.filter((x) => {
				return x.pspIndexId !== item.id;
			});
			return result;
		});
		setPSPIndexOptions((prevState) => {
			const result = [...prevState, ...deletedOption].sort((a, b) => {
				return a.displayOrder - b.displayOrder;
			});
			return result;
		});
	};

	const displayPSPIndexError =
		props.showErrors && currentSelectedPSPIndex.length < pspIndexesConstants.MIN_SELECTED_PSP_INDEXES;

	return (
		<StyledEditAccountPSPIndexModal className="StyledEditAccountPSPIndexModal">
			<SelectDropdown
				className={'pspindex-dropdown'}
				formLabel={labels.pspIndexDropdownLabel}
				isSearchable
				hideSelectedOptions
				value={selectedPSPIndexes}
				options={pspIndexOptions}
				onChange={optionSelectedHandler}
				isDisabled={props.isDropdownDisabled || isMaxPSPSelected}
				errorMessage={labels.pspIsRequired}
				showErrorMessage={displayPSPIndexError}
				keepFormLabelOnBlur
			/>
			{currentSelectedPSPIndex.length > 0 &&
				currentSelectedPSPIndex.map((item) => {
					return (
						<EditAccountPSPIndexModalItem id={item.pspIndexId} label={item.label} onItemClick={itemClickHandler} />
					);
				})}
		</StyledEditAccountPSPIndexModal>
	);
};

export default EditAccountPSPIndexModal;

const StyledEditAccountPSPIndexModal = styled.section`
	margin: var(--px-30) var(--px-20) var(--px-30) 0;
	.pspindex-dropdown {
		width: 40%;
		display: block;
		margin-bottom: var(--px-30);
		&.select-disabled {
			cursor: default;
		}
		&.select-error {
			.show {
				position: absolute;
			}
		}
	}
	.pspindex-list {
		width: 63.1%;
		@media only screen and (min-width: 1280px) and (max-width: 1367px) {
			width: 65.1%;
		}
		.pspindex-listitem {
			border-bottom: var(--px-1) solid var(--neutrals-300);
			padding: var(--px-10) 0 var(--px-2) 0;
			.pspindex-name {
				display: inline-block;
				width: 90%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.motif-button {
				float: right;
			}
		}
	}
`;
